/* unplugin-vue-components disabled */import script from "./head-view.vue?vue&type=script&setup=true&lang=js"
export * from "./head-view.vue?vue&type=script&setup=true&lang=js"

import "./head-view.vue?vue&type=style&index=0&id=1727cffa&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\work\\space-0\\fsplus-vue-workspace\\foshan-street\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1727cffa"]])

export default __exports__